import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Section, { Content } from './Section';
import PostPreview from './PostPreview';
import { LoadButton } from './Buttons';
import Spacer from './helpers/Spacer';

const mediaPath = process.env.REACT_APP_MEDIA_PATH;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 115px;
`;

export default function PostsGrid({
  posts,
  loading,
  currentPage,
  totalPages,
  onLoadMore
}) {
  const postsList = posts.map(({ id, title, embedded }, index) => {
    const url = embedded.featuredmedia
      ? `${mediaPath}/${embedded.featuredmedia[0].media_details.file}`
      : null;

    return (
      <PostPreview key={index} id={id} thumbnail={url} title={title.rendered} />
    );
  });

  // @todo: Implement pagination
  return (
    <Section>
      <Content>
        <Grid>{postsList}</Grid>
      </Content>

      {currentPage < totalPages && (
        <LoadButton onClick={onLoadMore} disabled={loading}>
          {loading ? 'Laster flere artikler…' : 'Se flere artikler'}
        </LoadButton>
      )}

      <Spacer />
    </Section>
  );
}

PostsGrid.propTypes = {
  posts: PropTypes.array.isRequired
};
